import { render, staticRenderFns } from "./CampanhaListagem.vue?vue&type=template&id=4aec702a&scoped=true"
import script from "./CampanhaListagem.vue?vue&type=script&lang=js"
export * from "./CampanhaListagem.vue?vue&type=script&lang=js"
import style0 from "./CampanhaListagem.vue?vue&type=style&index=0&id=4aec702a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aec702a",
  null
  
)

export default component.exports